import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-plus-slim_35c74bdaa2fb76e3c3b9f1687c6df63f",
  "use": "ic-plus-slim_35c74bdaa2fb76e3c3b9f1687c6df63f-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic-plus-slim_35c74bdaa2fb76e3c3b9f1687c6df63f\">\n    <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id